import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { CircularProgress, Grid } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  changePassword,
  setPassword,
  verifyPassword,
} from "../../../actions/password";
import snackbarUtils from "../../../utils/snackbarUtils";
import { StyledSetPassword } from "../../styled/setPassword";
import TextField from "../textField/textField";

const ComposedTextField = ({ type, handleClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const loadingSetPassword = useSelector(
    (state) => state.password.setPassword.isFetching,
  );
  const loadingVerifyPassword = useSelector(
    (state) => state.password.verifyPassword.isFetching,
  );
  const loadingChangePassword = useSelector(
    (state) => state.password.changePassword.isFetching,
  );

  const [password, setPasswordValue] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [validatePassword, setValidatePassword] = useState(false);
  const [validateConfirmPassword, setValidateConfirmPassword] = useState(false);

  const handleChangePassword = (value) => {
    setPasswordValue(value);
    setValidateConfirmPassword(false);
    setConfirmPassword("");
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();

    const dataUser = {
      Token: params.get("token"),
      Password: password,
    };

    const dataPassword = {
      CurrentPassword: currentPassword,
      Password: password,
    };

    if (type === "ActivateAccount") {
      dispatch(verifyPassword(dataUser))
        .then((data) => {
          if (data.action.payload?.status === 200) {
            snackbarUtils.success("¡Su cuenta se ha activado con éxito!");
            setTimeout(() => {
              navigate("/account/login");
            }, 3000);
          }
        })
        .catch(() => {});
    } else if (type === "ResetPassword") {
      dispatch(setPassword(dataUser))
        .then((data) => {
          if (data.action.payload?.status === 200) {
            snackbarUtils.success("¡Su contraseña se ha modificado con éxito!");
            setTimeout(() => {
              navigate("/account/login");
            }, 3000);
          }
        })
        .catch(() => {});
    } else if (type === "ChangePassword") {
      dispatch(changePassword(dataPassword))
        .then((data) => {
          if (data.action.payload?.status === 200) {
            snackbarUtils.success(`${data.action.payload.data}`);
            handleChangePassword("");
            setCurrentPassword("");
            setTimeout(() => {
              handleClose();
            }, 2000);
          }
        })
        .catch(() => {});
    }
  };

  const newPasswordInput = () => {
    if (type === "ChangePassword") {
      return (
        <Grid
          container
          direction="row"
          spacing={3}
          alignItems="flex-end"
          sx={StyledSetPassword.newPasswordInput}>
          <Grid item xs={1}>
            <LockOutlinedIcon sx={StyledSetPassword.icon} />
          </Grid>
          <Grid item xs={11}>
            <TextField
              setFieldValue={setCurrentPassword}
              validateInput={setValidatePassword}
              fieldValue={currentPassword}
              placeholder="Contraseña actual"
              rules={["require"]}
            />
          </Grid>
        </Grid>
      );
    }
  };

  return (
    <StyledSetPassword.Form onSubmit={handleSubmitForm}>
      {newPasswordInput()}
      <Grid container direction="row" spacing={3} alignItems="flex-end">
        <Grid item xs={1}>
          <LockOutlinedIcon sx={StyledSetPassword.icon} />
        </Grid>
        <Grid item xs={11}>
          <TextField
            setFieldValue={handleChangePassword}
            validateInput={setValidatePassword}
            fieldValue={password}
            placeholder="Nueva contraseña"
            rules={["require", "max", "min", "alphanumeric"]}
          />
        </Grid>
        <Grid item xs={1}>
          <LockOutlinedIcon sx={StyledSetPassword.icon} />
        </Grid>
        <Grid item xs={11}>
          <TextField
            setFieldValue={setConfirmPassword}
            fieldValue={confirmPassword}
            fullWidth
            placeholder="Confirmar contraseña"
            rules={["require", "match"]}
            valueToCompare={password}
            validateInput={setValidateConfirmPassword}
          />
        </Grid>
        <Grid item xs={12}>
          <StyledSetPassword.Button
            fullWidth
            variant="contained"
            color="primary"
            disabled={
              loadingVerifyPassword ||
              loadingSetPassword ||
              loadingChangePassword ||
              !validatePassword ||
              !validateConfirmPassword
            }
            type="submit">
            {loadingVerifyPassword ||
            loadingSetPassword ||
            loadingChangePassword ? (
              <CircularProgress
                sx={StyledSetPassword.progress}
                color="secondary"
              />
            ) : type === "ChangePassword" ? (
              "Cambiar contraseña"
            ) : (
              "Confirmar"
            )}
          </StyledSetPassword.Button>
        </Grid>
      </Grid>
    </StyledSetPassword.Form>
  );
};

export default ComposedTextField;
